// ========================
// == Floorplans directory promo CTAs: tan "A place to call home" and blue "Need help
// == deciding?" sit between card rows, per the mockups: three rows before tan and three
// == more before blue (five on one column). Shorter lists close the gaps evenly, keep at
// == least one row before and between, and drop blue under four rows.

/** Card rows before tan and between the CTAs on a full list. @type {number} */
const MAX_ROWS_BETWEEN = 3;
/** The one-column mockup spaces them further apart. @type {number} */
const MAX_ROWS_BETWEEN_ONE_COLUMN = 5;
/** @type {number} */
const MIN_ROWS_FOR_BLUE = 4;

/**
 * Grid rows for each CTA, or 0 for blue when the list is too short to show it.
 * @param {number} total Full result count, not just the cards loaded so far.
 * @param {number} columns
 * @returns {{tanRow: number, blueRow: number}}
 */
const ctaRows = (total, columns) => {
    const rows = Math.ceil(total / columns);
    const cap = columns === 1 ? MAX_ROWS_BETWEEN_ONE_COLUMN : MAX_ROWS_BETWEEN;
    const rowsBeforeTan = Math.min(cap, Math.ceil(rows / 3));
    const tanRow = rowsBeforeTan + 1;
    if (rows < MIN_ROWS_FOR_BLUE) {
        return { tanRow, blueRow: 0 };
    }
    const rowsBetween = Math.min(cap, Math.ceil((rows - rowsBeforeTan) / 2));
    return { tanRow, blueRow: tanRow + rowsBetween + 1 };
};

/**
 * Cards that fill the grid ahead of `row`. A CTA spans two columns, or the whole row on
 * one or two columns, so the tan row holds that many fewer cards.
 * @param {number} row
 * @param {number} columns
 * @param {number} ctasAbove
 * @returns {number}
 */
const cardsBeforeRow = (row, columns, ctasAbove) => (row - 1) * columns - ctasAbove * Math.min(2, columns);

/**
 * Place both CTAs for the current column count, and hide each until the cards before it
 * have loaded, so load-more never leaves one floating over empty rows.
 * @param {HTMLElement} grid The `.row` with `data-result-total`.
 * @returns {void}
 */
const layoutCtas = (grid) => {
    const tan = grid.querySelector("#list-cta-1");
    const blue = grid.querySelector("#list-cta-2");
    if (!tan || !blue) {
        return;
    }
    const total = Number(grid.dataset.resultTotal) || 0;
    const columns = getComputedStyle(grid).gridTemplateColumns.split(" ").length;
    const loadedCards = grid.querySelectorAll(".masterplan-col").length;
    const { tanRow, blueRow } = ctaRows(total, columns);

    tan.style.gridRowStart = String(tanRow);
    tan.hidden = loadedCards < Math.min(total, cardsBeforeRow(tanRow, columns, 0));
    blue.style.gridRowStart = blueRow ? String(blueRow) : "";
    blue.hidden = !blueRow || loadedCards < Math.min(total, cardsBeforeRow(blueRow, columns, 1));
};

const results = document.getElementById("oi-filter-results");
if (results) {
    /** @returns {void} */
    const layout = () => {
        const grid = results.querySelector(".row[data-result-total]");
        if (grid) {
            layoutCtas(grid);
        }
    };
    layout();
    // Filtering swaps in a new page 1 with a new total; load-more adds cards
    results.addEventListener("oifilter_results", layout);
    // The column count changes at the grid breakpoints
    window.addEventListener("resize", layout);
}
